/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

    document.addEventListener("DOMContentLoaded", () => {
        document.addEventListener("click", (e) => {
            const qty = document.querySelectorAll(".showProductPreorder .quantity__selector");
            qty.forEach(qty => {
                qty.addEventListener("change", (e) => {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    const el = document.querySelector('script[data-product-json]');
                    const product = JSON.parse(el.textContent);
                    const variant = product.variants[0];
                    let price = '';

                    if (product.available) {
                        price = variant.price;
                    }
                    price *= e.currentTarget.value;
                    var html = 0;
                    if (price === 0) {
                        html = window.theme.strings.free;
                    } else {
                        html = theme.settings.currency_code_enable ? window.theme.formatMoney(price, theme.moneyWithCurrencyFormat) : window.theme.formatMoney(price, theme.moneyFormat);
                    }
                    const preOrder = document.querySelectorAll('.gPreorderBtn');
                    const newDiv = document.createElement("span");
                    newDiv.textContent = html;
                    newDiv.className = "product__price--regular";
                    preOrder.forEach(btnPreOrder => {
                       let oldPrice = btnPreOrder.querySelector(".product__price--regular");
                       if (oldPrice) {
                           oldPrice.remove();
                       }
                        btnPreOrder.querySelectorAll('span')[0].appendChild(newDiv.cloneNode(true));
                    });
                },true);
            });
        }, true);
        document.addEventListener("change", (e) => {
            const gPreorderBtn = document.querySelectorAll(".showProductPreorder .gPreorderBtn");
            gPreorderBtn.forEach(gPreorderBtn => {
                gPreorderBtn.addEventListener("change", (e) => {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                },true);
            });
        }, true);
        const interval = setInterval(() => {
            const preorderElement = document.querySelector('.showProductPreorder');
            if (preorderElement ) {
                if (window.preorder_shipping_text) {
                    document.querySelector('.truck_block .product__icon__text').innerHTML = window.preorder_shipping_text;
                }
                clearInterval(interval);

                document.querySelector('.template-product').classList.add('preorder-pages');

            }
        }, 500);
        const intervalTrigger = setInterval(() => {
            const preorderElement = document.querySelector('.gPreorderBtn.gPreorderBtnLoaded,.gBackInStockBtn');
            if (preorderElement ) {
                clearInterval(intervalTrigger);
                setTimeout(function(){
                    const btn = document.querySelector('.quantity__btn--decrease');
                    const event = new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    });
                    btn.dispatchEvent(event);

                },2000)

            }
        }, 600);
    });






    // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
